
export const BUILD_INFO = {
  version: "0.13.0",
  buildDate: "2026-10-26T15:12:43.638Z",
  gitCommit: "6de2146",
  gitCommitFull: "6de2146cdb18bab26b9a14e20d9ad86337b846db",
  gitBranch: "fix/date-only-payloads",
  gitCommitMessage: "Merge remote-tracking branch 'origin' into fix/date-only-payloads",
  gitAuthor: "Emre Yazici",
  gitCommitDate: "2026-10-26T14:53:51Z",
  nodeVersion: "v22.14.0"
} as const;
